<nav class="sidebar-nav" [class.expanded]="expanded">
  <button
    class="hamburger-btn"
    (click)="toggleSidebar()"
    [attr.aria-label]="expanded ? 'Collapse sidebar' : 'Expand sidebar'"
    aria-live="polite"
  >
    <motif-icon [iconFunction]="IconoirMenu" size="24"></motif-icon>
  </button>

  <ul class="nav-list">
    @for (item of navItems; track item.link) {
      <li class="nav-item">
        <a
          [routerLink]="item.link"
          routerLinkActive="active"
          class="nav-link"
          [attr.aria-label]="item.label"
        >
          <motif-icon [iconFunction]="item.icon" size="24"></motif-icon>
          @if (expanded) {
            <span class="nav-label">{{ item.label }}</span>
          }
        </a>
      </li>
    }
  </ul>
</nav>
